
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navigation from '../components/Navigation';
import Sidebar from '../components/Sidebar';
import base_url from '../config/Config';
import PageLoader from '../components/PageLoader';

const ViewReject = () => {
    const navigate = useNavigate();
    const [customer, setCustomer] = useState([]);
    const [pageLoading] = useState(false);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');

    useEffect(() => {
        const getOneCustomer = async () => {
            try {
                const response = await axios.get(`${base_url}/api1/cibil/rejectListById`, { params: { id } });
                console.log(response.data);
                setCustomer([response.data]);
            } catch (error) {
                console.error("Error fetching Customer data:", error);
            }
        };

        if (id) {
            getOneCustomer();
        }
    }, [id]);

    const handleInputChange = (index, field, value) => {
        const updatedCustomer = [...customer];
        updatedCustomer[index] = {
            ...updatedCustomer[index],
            [field]: value
        };
        setCustomer(updatedCustomer);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            const updatedCustomer = await Promise.all(
                customer.map(async (data) => {
                    try {
                        const response = await axios.put(`${base_url}/api1/customer/updateCustomer?id=${data.id}`, data, {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        });
                        console.log("API Response:", response.data);
                        return response.data;
                    } catch (error) {
                        console.error(`Error updating Customer with ID ${data.id}:`, error.response?.data || error.message);
                        return data; // Return original data in case of error
                    }
                })
            );

            console.log("Customer updated successfully:", updatedCustomer);
            setCustomer(updatedCustomer);
            window.alert('Customer updated successfully');
            navigate('/operation/AllCustomer'); // Redirect after successful update
        } catch (error) {
            console.error("Error updating Customer:", error.message);
            // Handle error state or display error message to the user
        }
    };

    return (
        <>
            <div className='overviewsaa'>
                <h4>Customer View</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms phonedashbaord  mt-5'>
                            <div className='row'>
                                {/* Personal Details start  */}
                                
                                <div className='col-md-12 col-lg-12 '>
                                    <div className='personalhead pl-5'>
                                        <p>Personal Details</p>
                                    </div>
                                    { pageLoading ? <PageLoader text="Loading..." /> : customer.length > 0  ? (
                                 <form onSubmit={handleSubmit}>
                                <div className='dashboardlms mt-3'>
                                    <div className='row'>
                                        <div className='col-md-12 col-lg-12'>
                                            {customer.map((data, index) => (
                                            <div className='personaldetailsinformation mb-3' key={index}>
                                           <div className='row mb-5'>
                                           <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="id">Customer Id</label> <br />
                                                    <input type="text" name="id" id="id" value={'SCL0' + (data.id || '')} placeholder='Borrower ID' onChange={(e) => handleInputChange(index, 'id', e.target.value)} />
                                                    </div>
                                            </div>
                                            
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="partner_id">Partner Loan Id </label><br />
                                                    <input type="text" name="partner_id" id="partner_id"  value={data.partnerLoanId || ''} placeholder='Partner Loan Id ' onChange={(e) => handleInputChange(index, 'partnerLoanId', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="borrower_name">Borrower Name</label> <br />
                                                    <input type="text" name="borrower_name" id="borrower_name"  value={data.borrowerName || ''} placeholder='Borrower Name' onChange={(e) => handleInputChange(index, 'borrowerName', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="father_name">Father Name</label> <br />
                                                    <input type="text" name="father_name" id="father_name"  value={data.fatherName || ''} placeholder='Father Name' onChange={(e) => handleInputChange(index, 'fatherName', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="fintech_name">Fintech Name</label><br />
                                                    <input type="text" name="fintech_name" id="fintech_name"  value={data.employeeName || ''} placeholder='Fintech Name' onChange={(e) => handleInputChange(index, 'employeeName', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="mobile_number">Mobile Number</label><br />
                                                    <input type="text" name="mobile_number" id="mobile_number"  value={data.mobileNumber || ''} placeholder='Mobile Number' onChange={(e) => handleInputChange(index, 'mobileNumber', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="email">Email</label><br />
                                                    <input type="email" name="email" id="email"  value={data.email || ''} placeholder='Email' onChange={(e) => handleInputChange(index, 'email', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="dob">Date Of Birth </label><br />
                                                    <input type="text" name="dob" id="dob"  value={data.dob || ''} placeholder='DOB' onChange={(e) => handleInputChange(index, 'dob', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="date_of_joining">Date Of Joining </label><br />
                                                    <input type="text" name="date_of_joining" id="date_of_joining"  value={data.dobJoining || ''} placeholder='Date Of Joining' onChange={(e) => handleInputChange(index, 'dobJoining', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="gender">Gender</label><br />
                                                    <input type="text" name="gender" id="gender"  value={data.gender || ''} placeholder='Gender' onChange={(e) => handleInputChange(index, 'gender', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="company_name">Company Name</label><br />
                                                    <input type="text" name="company_name" id="company_name"  value={data.companyName || ''} placeholder='Comapny Name' onChange={(e) => handleInputChange(index, 'companyName', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="emp_id">Employee Id</label><br />
                                                    <input type="text" name="emp_id" id="emp_id"  value={data.empId || ''} placeholder='Empolyee Id' onChange={(e) => handleInputChange(index, 'empId', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="state_code">State Code</label><br />
                                                    <input type="text" name="state_code" id="state_code"  value={data.stateCode || ''} placeholder='State Code' onChange={(e) => handleInputChange(index, 'stateCode', e.target.value)}/>
                                                </div>
                                            </div>
                                            
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="pan_number"> PAN Number </label><br />
                                                    <input type="text" name="pan_number" id="pan_number"  value={data.panNumber || ''} placeholder='Pan Number' onChange={(e) => handleInputChange(index, 'panNumber', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="aadhar_number"> Aadhar Number </label><br />
                                                    <input type="text" name="aadhar_number" id="aadhar_number"  value={data.aadharNumber || ''} placeholder='Aadhar Number' onChange={(e) => handleInputChange(index, 'aadharNumber', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="create_date">Created Date</label><br />
                                                    <input type="text" name="create_date" id="create_date"  value={data.createdDate || ''} placeholder='Create Date' onChange={(e) => handleInputChange(index, 'createdDate', e.target.value)}/>
                                                </div>
                                            </div>
                                {/* Personal Details end  */}
                                {/* Resideltal Details start  */}
                                <div className='col-md-12 col-lg-12 '>
                                    <div className='personalhead text-justify mt-3'>
                                        <p>Residential Details</p>
                                    </div>
                                        <div className='row mb-5'>
                                        <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="address">Address</label><br />
                                                    <input type="text" name="address" id="address"  value={data.address || ''} placeholder='Address' onChange={(e) => handleInputChange(index, 'address', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="city">City</label><br />
                                                    <input type="text" name="city" id="city"  value={data.city || ''} placeholder='City' onChange={(e) => handleInputChange(index, 'city', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="state">State</label><br />
                                                    <input type="text" name="state" id="state"  value={data.state || ''} placeholder='State' onChange={(e) => handleInputChange(index, 'state', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="pincode">Pincode</label><br />
                                                    <input type="text" name="pincode" id="pincode" value={data.pinCode || ''}  placeholder='Pincode' onChange={(e) => handleInputChange(index, 'pinCode', e.target.value)}/>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                                {/* Resideltal Details end  */}
                                {/* professional details start  */}
                                <div className='col-md-12 col-lg-12 '>
                                    <div className='personalhead text-justify'>
                                        <p>Professional Details</p>
                                    </div>
                                        <div className='row mb-5'>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="company_name">Company Name</label> <br />
                                                    <input type="text" name="company_name" id="company_name"  value={data.companyName || ''} placeholder='Company Name' onChange={(e) => handleInputChange(index, 'companyName', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="position">Position </label><br />
                                                    <input type="text" name="position" id="position"  value={data.position || ''} placeholder='Position' onChange={(e) => handleInputChange(index, 'position', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="company_address">Company Address</label><br />
                                                    <input type="text" name="company_address" id="company_address"  value={data.companyAddress || ''} placeholder='Company Address' onChange={(e) => handleInputChange(index, 'companyAddress', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="email">Professional Email</label><br />
                                                    <input type="email" name="email" id="email"  value={data.professionalEmail || ''} placeholder='Professional Email' onChange={(e) => handleInputChange(index, 'professionalEmail', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="salary">Salary/Income</label><br />
                                                    <input type="text" name="salary" id="salary"  value={data.salary || ''} placeholder='Salary/Income' onChange={(e) => handleInputChange(index, 'salary', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="credit_limit">Credit Limit</label><br />
                                                    <input type="text" name="credit_limit" id="credit_limit"  value={data.creditLimit || ''} placeholder='Credit Limit' onChange={(e) => handleInputChange(index, 'salary', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="loan_amount">Request Loan Amount</label><br />
                                                    <input type="text" name="loan_amount" id="loan_amount"  value={data.loanAmount || ''} placeholder='Request Loan Amount' onChange={(e) => handleInputChange(index, 'loanAmount', e.target.value)}/>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                                {/* professional details end  */}
                               
                                {/* banking details start  */}
                                <div className='col-md-12 col-lg-12 '>
                                    <div className='personalhead text-justify'>
                                        <p>Banking Details</p>
                                    </div>
                                        <div className='row mb-5'>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="account_name">Account Name</label> <br />
                                                    <input type="text" name="account_name" id="account_name" value={data.accountName || ''} placeholder='Account Name' onChange={(e) => handleInputChange(index, 'accountName', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="account_number">Account Number</label><br />
                                                    <input type="text" name="account_number" id="account_number" value={data.accountNumber || ''} placeholder='Account Number' onChange={(e) => handleInputChange(index, 'accountNumber', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="ifsc_code">IFSC Code </label><br />
                                                    <input type="text" name="ifsc_code" id="ifsc_code"  value={data.ifscCode || ''} placeholder='IFSC Code' onChange={(e) => handleInputChange(index, 'ifscCode', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="bank_name">Bank Name</label><br />
                                                    <input type="text" name="bank_name" id="bank_name" value={data.bankName || ''} placeholder='Bank Name' onChange={(e) => handleInputChange(index, 'bankName', e.target.value)}/>
                                                </div>
                                            </div>
                                           
                                        </div>
                                </div>
                                {/* Banking details end  */}
                                
                                {/* Beuro details start  */}
                                <div className='col-md-12 col-lg-12 '>
                                    <div className='personalhead text-justify'>
                                        <p>Bureau Details</p>
                                    </div>
                                        <div className='row mb-5'>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="bureau_type">Bureau Type</label> <br />
                                                    <input type="text" name="bureau_type" id="bureau_type"  value={data.bureauType || ''} placeholder='Bureau Type' onChange={(e) => handleInputChange(index, 'bureauType', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="bureau_score">Bureau Score</label><br />
                                                    <input type="text" name="bureau_score" id="bureau_score" value={data.bureauScore || ''} placeholder='Bureau Score' onChange={(e) => handleInputChange(index, 'bureauScore', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="credit_type">Credit Type </label><br />
                                                    <input type="text" name="credit_type" id="credit_type" value={data.bureauDetails || ''} placeholder='Credit Type' onChange={(e) => handleInputChange(index, 'bureauDetails', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="status">Status</label><br />
                                                    <input type="text" name="status" id="status" value={data.status || ''} placeholder='Status' onChange={(e) => handleInputChange(index, 'status', e.target.value)}/>
                                                </div>
                                            </div>
                                           
                                        </div>
                                </div>
                                {/* Beruo details end  */}
                                  
                                {/* Other details start  */}
                                <div className='col-md-12 col-lg-12 '>
                                    <div className='personalhead text-justify'>
                                        <p>Other Details</p>
                                    </div>
                                    <div className='row mb-5'>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="other_details">Other Details</label> <br />
                                                    <input type="text" name="other_details" id="other_details"  value={data.otherDetails || ''} placeholder='Other Details' onChange={(e) => handleInputChange(index, 'otherDetails', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="other_details2">Other Deatils2</label><br />
                                                    <input type="text" name="other_details2" id="other_details2"  value={data.otherDetails2 || ''} placeholder='Other Deatils2' onChange={(e) => handleInputChange(index, 'otherDetails2', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="insurance_company">Insurance Company</label><br />
                                                    <input type="text" name="insurance_company" id="insurance_company"  value={data.insuranceCompany || ''} placeholder='Insurance Company' onChange={(e) => handleInputChange(index, 'insuranceCompany', e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-lg-3'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="reason">Reject Reason</label><br />
                                                    <input type="text" name="reason" id="reason" value={data.reason || ''} placeholder=' Reject Reason' onChange={(e) => handleInputChange(index, 'reason', e.target.value)}/>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                                {/* Beruo details end  */}
                               
                                </div>
                                </div>
                                ))}
                                {/* Co-Borrower end  */}
                                
                                <div className='col-md-12 col-lg-12'>
                                                <div className='buttonss mt-5 mb-5 text-center'>
                                                    <button type='submit'>Save</button>
                                                </div>
                                            </div>
                            </div>
                        </div>
                        </div>
                        </form>
            ) : (
                "No Customer  details to view"
            )}
                    </div>
                    
                </div>
               
        </div>
        </div>
        </div>
        </div>
        
        </>
    );
};

export default ViewReject;